import { all, call, fork, put, takeLatest } from "redux-saga/effects";
import actions from "./actions";
import {
  acceptAggrementServiceFailed,
  acceptAggrementServiceSuccess,
  createOtpServiceFailed,
  createOtpServiceSuccess,
  getAggrementServiceFailed,
  getAggrementServiceSuccess,
  loginServiceFailed,
  loginServiceSuccess,
  postOtpServiceFailed,
  postOtpServiceSuccess,
  registerServiceFailed,
  registerServiceSuccess,
  getUserByIdSuccess,
  getUserByIdFailed,
} from "./services";
import { login, register, getUserById } from "../../api/auth";

// custom sagas
function* watchRegisterService() {
  yield takeLatest(actions.REGISTER_SERVICE_REQUEST, registerService);
}
function* registerService(action) {
  try {
    const res = yield call(register, action.payload);
    let result = res.data;
    yield put(
      registerServiceSuccess({
        data: result,
      })
    );
  } catch (err) {
    console.log("REGISTER ERROR:", err.response?.data);
    yield put(registerServiceFailed(err.response?.data || err.message));
  }
}

function* watchLoginService() {
  yield takeLatest(actions.LOGIN_SERVICE_REQUEST, loginService);
}
function* loginService(action) {
  try {
    const res = yield call(login, action.payload);
    let result = res.data;
    if (result && result.tokens && result.tokens.access && result.tokens.access.token) {
      localStorage.setItem("auth_token", result.tokens.access.token);
      localStorage.setItem("auth_user", JSON.stringify(result.data || {}));
    }
    yield put(
      loginServiceSuccess({
        data: result,
      })
    );
  } catch (err) {
    console.log("LOGIN ERROR:", err.response?.data);
    yield put(loginServiceFailed(err.response?.data || err.message));
  }
}

function* watchPostOtpService() {
  yield takeLatest(actions.POST_OTP_SERVICE_REQUEST, postOtpService);
}
function* postOtpService(action) {
  try {
    const res = yield call(
      apiCall,
      "post",
      "auths/access-token",
      action.payload
    );
    let result = res.data.body;
    localStorage?.setItem("token", result?.token);
    yield put(
      postOtpServiceSuccess({
        data: result,
      })
    );
  } catch (err) {
    console.log(err);
    yield put(postOtpServiceFailed({ data: err?.response?.data?.message }));
  }
}

function* watchGetAggrementService() {
  yield takeLatest(actions.GET_AGGREMENT_SERVICE_REQUEST, getAggrementService);
}
function* getAggrementService(action) {
  try {
    const res = yield call(
      apiCall,
      "get",
      "handshake-agreement-events/by-event-name/user_creation"
    );
    let result = res.data.body;
    yield put(
      getAggrementServiceSuccess({
        data: result,
      })
    );
  } catch (err) {
    console.log(err);
    yield put(getAggrementServiceFailed());
  }
}

function* watchAcceptAggrementService() {
  yield takeLatest(
    actions.ACCEPT_AGGREMENT_SERVICE_REQUEST,
    acceptAggrementService
  );
}
function* acceptAggrementService(action) {
  try {
    const res = yield call(
      apiCall,
      "post",
      "handshake-agreement-approvals",
      action.payload
    );
    let result = res.data.data;
    yield put(
      acceptAggrementServiceSuccess({
        data: result,
      })
    );
  } catch (err) {
    console.log(err);
    yield put(acceptAggrementServiceFailed());
  }
}

function* watchCreateOtpService() {
  yield takeLatest(actions.CREATE_OTP_SERVICE_REQUEST, createOtpService);
}
function* createOtpService(action) {
  try {
    const res = yield call(apiCall, "post", "auths/otp", action.payload);
    let result = res.data.data;
    yield put(
      createOtpServiceSuccess({
        data: result,
      })
    );
  } catch (err) {
    yield put(createOtpServiceFailed({ data: err?.response?.data }));
  }
}

function* getUserByIdSaga(action) {
  try {
    const res = yield call(getUserById, action.payload);
    let result = res.data;
    yield put(getUserByIdSuccess({ data: result }));
  } catch (err) {
    console.log("GET USER BY ID ERROR:", err.response?.data);
    yield put(getUserByIdFailed(err.response?.data || err.message));
  }
}

export default function* authSaga() {
  yield all([
    fork(watchRegisterService),
    fork(watchLoginService),
    fork(watchPostOtpService),
    fork(watchGetAggrementService),
    fork(watchAcceptAggrementService),
    fork(watchCreateOtpService),
    takeLatest(actions.GET_USER_BY_ID_REQUEST, getUserByIdSaga),
  ]);
}